/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, TableCell, TableHead, TableRow, Typography, styled, useTheme } from '@mui/material';
import { SEED_MIX_TYPE } from '../types/SeedOrderFormType';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.colors.primary50,
  },
}));

export const StyledTableRowMobile = styled(Box)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.colors.primary50,
  },
  borderBottom: `1px solid ${theme.colors.primary100}`,
}));

type TableCellProps = {
  label: string;
  textAlign?: 'end' | 'start';
};

export const TableCellContent = ({ label, textAlign = 'end' }: TableCellProps) => (
  <Typography variant='body2' textAlign={textAlign}>
    {label}
  </Typography>
);

const TableTitle = ({ label, textAlign = 'end' }: TableCellProps) => {
  const theme = useTheme();
  return (
    <TableCell>
      <Typography
        variant='body2'
        color={theme.colors.primary500}
        fontWeight='bold'
        textAlign={textAlign}
        p={2}
      >
        {label}
      </Typography>
    </TableCell>
  );
};

export const SeedTableHeader = ({ mixType }: { mixType?: SEED_MIX_TYPE }) => (
  <TableHead>
    <TableRow>
      <TableTitle label='SKU' textAlign='start' />
      <TableTitle label='Goods Supplied' textAlign='start' />
      {mixType === SEED_MIX_TYPE.CUSTOM ? <TableTitle label='Sowing rate' /> : null}
      <TableTitle label='Quantity' />
      <TableTitle label='Unit Price' />
      <TableTitle label='Total (GST excl.)' />
    </TableRow>
  </TableHead>
);
